import React, { useState, useEffect } from "react";
import { Form, Input, Button, Checkbox } from "antd";
import axios from "axios";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { appActions } from "../Store/store";
import { useNavigate, Link } from "react-router-dom";
import "./login.css";
import surveyorIcon from '../login/surveyorIcon.png';
import illustration from '../login/illustration.png';

const BasicLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [authenticationFailed, setAuthenticationFailed] = useState(false);
  const [usernameHelperMessage, setUsernameHelperMessage] = useState(null);
  const [passwordHelperMessage, setPasswordHelperMessage] = useState(null);
  const [rememberMe, setRememberMe] = useState(false);

  const handleInputChange = (type, e) => {
    let value = e.target.value;

    if (type === 'username') {
      if (!value && value.length < 0) {
        setUsernameHelperMessage('Username cannot be empty');
      } else {
        setUsernameHelperMessage(null);
        setUsername(value);
      }
    }

    if (type === 'password') {
      if (!value && value.length < 0) {
        setPasswordHelperMessage('Password cannot be empty');
      } else {
        setPasswordHelperMessage(null);
        setPassword(value);
      }
    }
  };

  const [form] = Form.useForm();

  const onFinish = async values => {
    if (!values.Username) {
      setUsernameHelperMessage('Username cannot be empty');
    } else {
      setUsernameHelperMessage(null);
    }

    if (!values.Password) {
      setPasswordHelperMessage('Password cannot be empty');
    } else {
      setPasswordHelperMessage(null);
    }

    setLoading(true);

    try {
      const response = await axios.post('/auth/authenticate', {
        username: values.Username,
        password: values.Password
      });
     

      localStorage.setItem('insuranceUser', JSON.stringify(response.data));
      sessionStorage.setItem('loggedInUser', response.data.org_id);

      if (values.rememberMe) {
        document.cookie = `username=${values.Username}; path=/`;
        document.cookie = `password=${values.Password}; path=/`;
      } else {
        document.cookie = 'username=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        document.cookie = 'password=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      }
      setLoading(false);
      dispatch(appActions.addUser(response.data));
      console.log("112", response.data);
      navigate('/app/home');
    } catch (err) {
      console.log('error', err);
      setLoading(false);
      setAuthenticationFailed(true);
    }
  };
  const handleForgetPassword = () => {
    navigate("/forgot-password");
  }
  useEffect(() => {
    const cookies = document.cookie.split('; ').reduce((prev, curr) => {
      const [key, value] = curr.split('=');
      prev[key] = value;
      return prev;
    }, {});

    if (cookies.username) {
      setUsername(cookies.username);
      form.setFieldsValue({ Username: cookies.username });
    }

    if (cookies.password) {
      setPassword(cookies.password);
      form.setFieldsValue({ Password: cookies.password });
    }
  }, [form]);
  return (
    <div className="responsive-login-container">
      <div className="login-illustration">
        <img src={illustration} alt="Illustration" />
      </div>
      <div className="login-form-container">
        {/* <img src={surveyorIcon} alt="Surveyor's AI" className="surveyor-icon" /> */}
        <div className="signin-text">Sign in to your account</div>
        <Form
          className="form-data"
          form={form}
          onFinish={onFinish}
          layout="vertical"
        >
          <div className="login-basic">
            <Form.Item
              name="Username"
              help={<span style={{ color: 'red' }}>{usernameHelperMessage}</span>}
            >
              <div className="email-container">
                <Input
                  value={username}
                  placeholder="Email address"
                  onChange={(e) => handleInputChange("username", e)}
                />
              </div>
            </Form.Item>

            <Form.Item
              name="Password"
              help={<span style={{ color: 'red' }}>{passwordHelperMessage}</span>}
            >
              <div className="password-container">
                <Input.Password
                  value={password}
                  placeholder="Password"
                  onChange={(e) => handleInputChange("password", e)}
                />
              </div>
            </Form.Item>

            <Form.Item name="rememberMe" valuePropName="checked" className="remember-me">
              <Checkbox >Remember me</Checkbox>
            </Form.Item>


            <Form.Item className="login-btn-container">
              <Button className="login-btn" type="primary" htmlType="submit">
                Login {loading && <Loading3QuartersOutlined spin />}
              </Button>
              <div className="helper-text">
                {authenticationFailed && <span>Invalid credentials, please try again...</span>}
              </div>
              <div className="forgot-password" onClick={handleForgetPassword}>Forgot Password</div>
              {/* <Link to="/forgot-password" className="forgot-password">Forgot Password</Link> */}

            </Form.Item>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default BasicLogin;
